export const Types = {
    SAVE_LIST_LOAN: 'SAVE_LIST_LOAN',
    SAVE_LIST_USER_LOAN: 'SAVE_LIST_USER_LOAN',
    SAVE_HISTORY_PAYMENT: 'SAVE_HISTORY_PAYMENT',
}
